module.exports = __webpack_public_path__ + "static/media/024_A_infopanel.8d12435b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/optus/024_A_infopanel.png
// module id = 589
// module chunks = 0